import { ThreadMessage } from "./SDKThreadMessage";
import { ThreadMessageReaction } from "./SDKThreadMessageReaction";
export class ThreadMessageList {
    constructor(model) {
        this.messages = model.messages.map((message) => new ThreadMessage(message));
        this.reactions = model.reactions.map((reaction) => new ThreadMessageReaction(reaction));
        this.lastSeenMessageId = model.lastSeenMessageId;
    }
    toRemote() {
        return {
            messages: this.messages.map((message) => message.toRemote()),
            reactions: this.reactions.map((reaction) => reaction.toRemote()),
            lastSeenMessageId: this.lastSeenMessageId,
        };
    }
}
